import { getStoreUrl } from "../store/utils"
import { categoriesManageToolbar } from "./toolbar"
const { createCardRoutes } = require("lib/core/routing/card-routing")
const { loadCategories, selectCategory } = require("./middleware")

// HACK: for "passing" /client/main components to /client/features
window.categoriesManageToolbar = categoriesManageToolbar

export const cardRoutes = {
  category: {
    component: require("./list/CategoryListCard").default,
    middleware: loadCategories,
    getDefaultLaunchedFrom: () => getStoreUrl(),
    childCards: {
      item: {
        path: ":categoryId(\\d+|new)/",
        middleware: selectCategory,
        component: require("./item/CategoryFormCard").default
      }
    }
  }
}

const fallbackComponent = require("store/StoreOrLibraryBrowse").default

export default createCardRoutes("/manage/", cardRoutes, fallbackComponent)
